import { EntityDocfile } from "./EntityDocfile";

export class EntityDocfileImple extends EntityDocfile {
  public url4Show: string | null = null;
}
